import { Service } from '@tino-frontend/adapters'

export type ResendKycParams = {
  phone: string
  user_id: string
}

export type ResendOptinParams = {
  phone: string
  user_id: string
}

export class ValidationsService {
  constructor(private readonly supplierBFF: Service) {}

  async resendKycLink(merchantId: string, params?: ResendKycParams) {
    return this.supplierBFF.post(
      `/v1/validations/kyc/${merchantId}/resend`,
      params
    )
  }

  async resendOptInLink(merchantId: string, params?: ResendOptinParams) {
    return this.supplierBFF.post(
      `/v1/validations/optin/${merchantId}/resend`,
      params
    )
  }
}
